// extracted by mini-css-extract-plugin
export default {"CommentListPlaceholder":"ih_a bht_jk","CommentListPlaceholder--Legacy":"ih_b bht_rc bht_wq"};